module.exports = __webpack_public_path__ + "static/media/bottom_banner_9_1.89e19050.png";